// @mui
import { Stack } from '@mui/material';
import { memo } from 'react';

//
import type { NavListProps, NavSectionProps } from '../types';

// utils
import { hideScrollbarY } from '../../../utils/cssStyles';
import NavList from './NavList';

const NavSectionHorizontal = ({ data, sx, ...other }: NavSectionProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mx: 'auto',
        ...hideScrollbarY,
        ...sx,
      }}
      {...other}
    >
      {data.map((group) => (
        <Items items={group.items} key={group.subheader} />
      ))}
    </Stack>
  );
};

export default memo(NavSectionHorizontal);

// ----------------------------------------------------------------------

type ItemsProps = {
  items: NavListProps[];
};

const Items = ({ items }: ItemsProps) => {
  return (
    <>
      {items.map((list) => (
        <NavList
          data={list}
          depth={1}
          hasChild={!!list.children}
          key={list.title + list.path}
        />
      ))}
    </>
  );
};
